type PropType = { quoteCount: number }
const QuoteCountBadge = (props: PropType) => {
  const { quoteCount = 0 } = props
  return (
    <div
      style={{
        background:
          'linear-gradient(90deg, rgba(249, 156, 135, 0.15) 0%, rgba(240, 188, 110, 0.15) 100%)',
      }}
      className="flex items-center justify-center px-3"
    >
      <p className="leading-8 text-xs font-medium text-[#F37E5D]">
        {`استعلام قیمت: ${quoteCount} بار`}
      </p>
    </div>
  )
}

export default QuoteCountBadge
